import Settings from 'Settings'

import AnalyticsUtils from '@daedalus/core/src/analytics/utils'

const ANALYTICS_ENDPOINT = Settings.get('REACT_APP_ANALYTICS_ENDPOINT')
const API_KEY = Settings.get('REACT_APP_ANALYTICS_API_KEY')

export default (anonymousId: string) => {
  const integrations = {
    'Segment.io': {
      apiKey: API_KEY,
      apiHost: ANALYTICS_ENDPOINT
    }
  }

  AnalyticsUtils.initialize(integrations, anonymousId)
}
